<template>
  <div class="tw-bg-white tw-rounded-xl tw-shadow-md tw-p-6 tw-border tw-border-slate-100">
    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-50">
        <svg
          class="tw-h-5 tw-w-5 tw-text-amber-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div>
        <h3 class="tw-text-base tw-font-semibold tw-text-slate-900">
          Order pending acceptance
        </h3>
        <p class="tw-mt-1 tw-text-sm tw-text-slate-600">
          Thanks — we've received your request to add this quote to your account. Your order is now pending acceptance and a confirmation will be sent shortly.
        </p>
        <p
          v-if="reference"
          class="tw-mt-3 tw-text-sm tw-font-medium tw-text-slate-800"
        >
          Reference: <span class="tw-font-semibold">{{ reference }}</span>
        </p>
        <button
          class="tw-mt-5 tw-w-full tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-transparent tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2"
          @click="$emit('close')"
        >
          Close window
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PendingAcceptanceCard',
  props: {
    reference: {
      type: String,
      default: ''
    }
  },
  emits: ['close']
}
</script>
